export function renderCompareRow({
  label,
  values,
  productsLength,
  maxCompare,
}: {
  label: string;
  values: string[];
  productsLength: number;
  maxCompare: number;
}): string {
  const cells = values
    .map(
      (value) => `
        <div class="w-[144px] m:w-[200px] flex-1 shrink-0 p-2x">
          <div class="body-m m:body-l compare-value">
            ${value}
          </div>
        </div>
      `,
    )
    .join('');

  const emptyCells = Array(maxCompare - productsLength)
    .fill('<div class="w-[144px] m:w-[200px] flex-1 shrink-0 p-2x">—</div>')
    .join('');

  return `
    <div class="compare-row mb-1x flex flex-col px-2x py-3x rounded-m border-secondary hover:bg-secondary">
      <span class="label-m mb-1x px-2x">
        ${label}
      </span>

      <div class="flex gap-2x m:gap-6x items-start body-l">
        ${cells}
        ${emptyCells}
      </div>
    </div>
  `;
}
